






































































































import { Component, Prop, Mixins } from "vue-property-decorator";

// Mixins
import { FilteringSortingTableStore } from "@/mixins/tableWithFilteringAndSortingStore";

// Enums/Data
import { DataModules } from "@/store/modules/data";
import { AffiliatePayoutFilters } from "@/data/filters/affiliate";
import { AffiliatePayoutSorters } from "@/data/sorters/affiliate";

// Types
import { IFilter, ISorter } from "@/models/tables";
import { IAccount } from "@/models/accounts";

@Component
export default class PayoutsHistoryTable extends Mixins(
  FilteringSortingTableStore
) {
  // Props

  @Prop({ required: true })
  public accountId!: IAccount["id"];

  @Prop({ default: 10 })
  public declare limit: number;

  @Prop({ default: "APHT1" })
  public declare id: string;

  // Data

  public dataModule = DataModules.AFFILIATES_PAYOUTS;
  public filters: IFilter[] = AffiliatePayoutFilters;
  public sorters: ISorter[] = AffiliatePayoutSorters;
  public guardFunctionalities = ["list_affiliate_account_commission_payouts"];

  // Computed

  public get contentIsAvailable() {
    return this.$userCan(...this.guardFunctionalities);
  }

  // Life-cycle methods

  public async created() {
    if (!this.contentIsAvailable) return;
    this.apiProps = {
      with: "affiliate_payout_destination"
    };
    this.getData();
  }

  // Methods

  public async reloadData() {
    this.getData({ ignoreStored: true });
  }

  // Overrides 'FilteringSortingTableStore' method

  public getStoreParams(payload: any): Promise<any> {
    return {
      ...payload,
      accountId: this.accountId
    };
  }
}
